<div class="logged-out">
  <section class="logged-out-card">
    <div class="brand">
      <img class="brand-logo" src="/assets/logo.svg" alt="Youtopia logo" />
      <span class="brand-name">Youtopia Admin</span>
      <yt-environment-badge />
    </div>

    @if (isExpired()) {
      <h1 class="logged-out-title">Your session has expired</h1>
      <p class="logged-out-info">
        For your security you've been signed out. Sign in again to pick up where you left off.
      </p>
    } @else {
      <h1 class="logged-out-title">Welcome to Youtopia Admin</h1>
      <p class="logged-out-info">Sign in with your Youtopia account to manage the platform.</p>
    }

    <p-button label="Log in" icon="pi pi-sign-in" styleClass="logged-out-login" [rounded]="true" (onClick)="login()" />

    <ul class="logged-out-highlights">
      <li>
        <i class="pi pi-shopping-cart"></i>
        Orders
      </li>
      <li>
        <i class="pi pi-comments"></i>
        Multi-Agent System
      </li>
      <li>
        <i class="pi pi-users"></i>
        Directory &amp; Teams
      </li>
      <li>
        <i class="pi pi-wrench"></i>
        Diagnostics
      </li>
    </ul>
  </section>
</div>
